import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { CurrencyNote } from "./CurrencyNote";
import { packageIncludes } from "../data/page";
import { images, PRICE } from "../data/offer";
export function FinalCtaSection() {
  return <section className="bg-navy-900 px-4 py-16 text-white sm:px-6 sm:py-24" data-id="element-163" data-mp="3vq9txj4rp5ms">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="2y6f2m93a0zh5">
        <div className="text-center" data-id="element-165" data-mp="333p2yjs7evjr">
          <h2 className="font-display text-[2.1rem] font-bold uppercase leading-[1.06] sm:text-5xl" data-id="element-166" data-mp="334qesqh1nm2j">
            Ready to organize your diabetic foot assessment knowledge?
          </h2>
          <p className="mt-4 text-lg font-semibold text-accent" data-id="element-167" data-mp="3cuthjidywee2">
            Six educational volumes. Five specialized bonuses. One organized reference collection.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-168" data-mp="2kcxlsw1z60ut">
            You don't need to keep collecting disconnected notes every time you want to revisit a diabetic foot
            assessment topic.
          </p>
        </div>

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-2" data-id="element-169" data-mp="28dp0qdi0csgl">
          <img src={images.mockup} alt="" className="-mx-4 w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full" loading="lazy" data-id="element-170" data-mp="23kvzhzlr0299" />
          <div data-id="element-171" data-mp="1ymu7gp6cgsln">
            <p className="font-display text-xl font-bold uppercase" data-id="element-172" data-mp="1yl9jjiejc7wr">Your complete package includes:</p>
            <ul className="mt-4 space-y-3" data-id="element-173" data-mp="1pmfh3beiwnba">
              {packageIncludes.map(p => <li key={p} className="flex gap-3 text-base text-white/90" data-id="element-174" data-mp="1pos9kihwqg2l">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success" data-id="element-175" data-mp="1knl0mg413auc">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-176" data-mp="1fqm82200jby9" />
                  </span>
                  {p}
                </li>)}
            </ul>
            <p className="mt-8 font-display text-2xl font-bold uppercase" data-id="element-177" data-mp="3a06flc94zxdm">
              Get the complete blueprint for just <span className="text-5xl text-cta" data-id="element-178" data-mp="1d3tl8yj25jk6">${PRICE}</span> USD
            </p>
            <p className="mt-1 text-white/75" data-id="element-179" data-mp="1d5wmkepnuz47">One-time payment. No monthly fees.</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-8" data-id="element-180" data-mp="13e0afzqqp8gz">
          <CtaButton label="Yes — get the blueprint" microcopy="Digital educational resource · Review checkout details before purchasing" tone="dark" data-id="element-181" data-mp="13es8ribq1kay" />
          <Countdown data-id="element-182" data-mp="1w1cyyfggnqcx" />
          <ScarcityBar data-id="element-183" data-mp="1w1wexqmjw4ob" />
          <CurrencyNote data-id="element-184" data-mp="1i2wteruc45wd" />
        </div>
      </div>
    </section>;
}